import { Injectable } from '@angular/core';
import {
  AppConfigService as AppConfig,
  Configuration
} from '../services/init/app-config.service';
import { OrderApiConstant } from '../constants/parmed-api.constant';
import { BaseApi } from './base-api';

@Injectable()
export class OrderApi extends BaseApi {
  /******************Properties******************/
  readonly GET_ORDERS_URL: string = OrderApiConstant.GET_ORDERS;
  readonly ADD_TO_CART_URL: string = OrderApiConstant.ADD_TO_CART;
  readonly VIEW_CART_URL: string = OrderApiConstant.VIEW_CART;
  readonly VIEW_ORDER_URL: string = OrderApiConstant.VIEW_ORDER;
  readonly UPDATE_ORDER_URL: string = OrderApiConstant.UPDATE_ORDER;
  readonly GET_ORDER_COUNT_URL: string = OrderApiConstant.GET_ORDER_COUNT;
  readonly GET_ORDER_HISTORY_URL: string = OrderApiConstant.GET_ORDER_HISTORY;
  readonly GET_ORDER_HISTORY_DETAIL_URL: string =
    OrderApiConstant.GET_ORDER_HISTORY_DETAIL;
  readonly GET_ORDER_HISTORY_DETAIL_FACTS_URL: string =
    OrderApiConstant.GET_ORDER_HISTORY_FACTS_DETAIL;
  readonly GET_ORDER_TRACKING_DETAIL_URL: string =
    OrderApiConstant.GET_ORDER_TRACKING_DETAIL;
  readonly GET_SUBMITTED_CSOS_ORDERS_URL: string =
    OrderApiConstant.GET_SUBMITTED_CSOS_ORDERS;
  readonly GET_CSOS_SUBMITTED_ORDER_DETAIL_URL: string =
    OrderApiConstant.GET_CSOS_SUBMITTED_ORDER_DETAIL;
  readonly GET_CSOS_SUBMITTED_ORDER_DETAILS_URL: string =
    OrderApiConstant.GET_CSOS_SUBMITTED_ORDER_DETAILS;
  readonly SAVE_CSOS_SUBMITTED_ORDER_DETAILS_URL: string =
    OrderApiConstant.SAVE_CSOS_SUBMITTED_ORDER_DETAILS;
  readonly ORDER_SUMMARY_URL: string = OrderApiConstant.ORDER_SUMMARY;
  readonly GET_UNIQUE_TRACKING_NUMBER_URL: string =
    OrderApiConstant.GET_UNIQUE_TRACKING_NUMBER;
  readonly CHECK_OUT_ORDERS_URL: string = OrderApiConstant.CHECK_OUT_ORDERS;
  readonly CERT_PWD_ENCRYPT_URL: string = OrderApiConstant.CERT_PWD_ENCRYPT;
  readonly SEARCH_TRACK_AND_TRACE_URL: string =
    OrderApiConstant.SEARCH_TRACK_AND_TRACE;
  readonly TRACK_AND_TRACE_DETAILS_URL: string =
    OrderApiConstant.TRACK_AND_TRACE_DETAILS;
  readonly RETURN_PRODUCT_URL: string = OrderApiConstant.RETURN_PRODUCT;
  readonly PRODUCT_RETURN_SEARCH_URL: string =
    OrderApiConstant.PRODUCT_RETURN_SEARCH;
  readonly GET_PREBOOK_PRODUCT_URL: string =
    OrderApiConstant.GET_PREBOOK_PRODUCT;
  readonly SUBMIT_PREBOOK_PRODUCT_URL: string =
    OrderApiConstant.SUBMIT_PREBOOK_PRODUCT;
    readonly GET_INVOICE_DATA_URL: string =
    OrderApiConstant.GET_INVOICE_DATA;
  readonly DOWNLOAD_INVOICE_URL: string = OrderApiConstant.DOWNLOAD_INVOICE;
  readonly PAY_INVOICE_URL: string = OrderApiConstant.PAY_INVOICE;
  readonly DOWNLOAD_DSCSA_URL: string =
    OrderApiConstant.DOWNLOAD_DSCSA;
  readonly DOWNLOAD_DSCSA_BASE64_URL: string =
    OrderApiConstant.DOWNLOAD_DSCSA_BASE64;
  readonly GET_DSCSA_REPORTING_URL: string =
  OrderApiConstant.GET_DSCSA_REPORTING;
  readonly DOWNLOAD_INVOICE_BASE64_URL: string = OrderApiConstant.DOWNLOAD_INVOICE_BASE64;
  readonly MEDIA_UPLOAD_URL: string = OrderApiConstant.MEDIA_UPLOAD_URL;
  readonly UPDATE_Rejected_ORDER_URL: string = OrderApiConstant.UPDATE_REJECTED_ORDER;
  readonly GET_ITEM_SERIALIZATION_URL: string =OrderApiConstant.GET_ITEM_SERIALIZATION;
  readonly SERIAL_NUMBER_CHECK_URL: string =OrderApiConstant.CHECK_SERIAL_NUMBER;
  /******************Properties******************/

  /***************Constructor***************/
  constructor(config: AppConfig) {
    super(config, Configuration.ORDER_API_ENDPOINT);
    this.reset(this);
  }
  /***************Constructor***************/
}
